import { AddRefusal, AppDebug, ChangeApproval, ItemDetailsPage, ItemVerificationPage, LoadAppointmentPage, LoadAssignmentsPage, LoadEquipments, LogoutPage, LpDetailsPage, MassRefusePage, MassVerifyPage, MispicksPage, RecapPage, StopOverviewPage, SupplierPickup, TempIntegrityPage, TestBarcodesPage, TestPage, VerifyItemPage, VerifyReturnItemPage, EditCompanyEmailsPage } from 'pages';
import { NavigationRoute } from 'services/types';


const routes: NavigationRoute[] = [
  {
    id: 1,
    path: '/load-assignments',
    component: LoadAssignmentsPage,
    title: 'Load Assignments',
    backButtonVisible: false
  },
  {
    id: 2,
    path: '/load-appointments',
    component: LoadAppointmentPage,
    title: 'Appointments',
    backButtonVisible: true
  },
  {
    id: 3,
    path: '/temp-integrity',
    component: TempIntegrityPage,
    title: 'Temperature Integrity',
    backButtonVisible: true
  },
  {
    id: 4,
    path: '/stop-overview',
    component: StopOverviewPage,
    title: 'Stop Overview',
    backButtonVisible: true
  },
  {
    id: 5,
    path: '/mass-verify',
    component: MassVerifyPage,
    title: 'Mass Verify',
    backButtonVisible: true
  },
  {
    id: 6,
    path: '/mass-refuse',
    component: MassRefusePage,
    title: 'Mass Refuse',
    backButtonVisible: true
  },
  {
    id: 7,
    path: '/item-verification',
    component: ItemVerificationPage,
    title: 'Item Verification',
    backButtonVisible: true
  },
  {
    id: 8,
    path: '/item-details',
    component: ItemDetailsPage,
    title: 'Item Details',
    backButtonVisible: true
  },
  {
    id: 9,
    path: '/lp-details',
    component: LpDetailsPage,
    title: 'LP Details',
    backButtonVisible: true
  },
  {
    id: 10,
    path: '/add-refusal',
    component: AddRefusal,
    title: 'Add Refusal',
    backButtonVisible: true
  },
  {
    id: 11,
    path: '/load-equipments',
    component: LoadEquipments,
    title: 'Load Equipments',
    backButtonVisible: true
  },
  {
    id: 12,
    path: '/mispicks',
    component: MispicksPage,
    title: "Mispicks",
    backButtonVisible: true
  },
  {
    id: 13,
    path: '/verify-returnitem',
    component: VerifyReturnItemPage,
    title: 'Verify Return Item',
    backButtonVisible: true
  },
  {
    id: 14,
    path: '/verify-item',
    component: VerifyItemPage,
    title: 'Verify Item',
    backButtonVisible: true
  },
  {
    id: 15,
    path: '/recap',
    component: RecapPage,
    title: "Recap",
    backButtonVisible: true
  },
  {
    id: 16,
    path: '/supplier-pickup',
    component: SupplierPickup,
    title: "Supplier Pickup",
    backButtonVisible: true
  },
  {
    id: 17,
    path: '/change-approval',
    component: ChangeApproval,
    title: "Change Approval",
    backButtonVisible: true
  },
  {
    id: 18,
    path: '/edit-company-emails',
    component: EditCompanyEmailsPage,
    title: 'Edit E-Mails',
    backButtonVisible: true
  },
  {
    id: 96,
    path: '/app-debug',
    component: AppDebug,
    title: "App Debug",
    backButtonVisible: true
  },
  {
    id: 97,
    path: '/test-page',
    component: TestPage,
    title: 'Test Page',
    backButtonVisible: true
  },
  {
    id: 98,
    path: '/test-barcodes',
    component: TestBarcodesPage,
    title: 'Barcodes',
    backButtonVisible: true
  },
  {
    id: 99,
    path: '/logout',
    component: LogoutPage,
    title: 'Logout',
    backButtonVisible: true
  }
];

export default routes